var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        [
          _c(
            "span",
            { attrs: { slot: "label" }, slot: "label" },
            [
              _vm._v(" 其他选项必填 "),
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    content: '如果选项中开启"其他"选项，此属性控制该值是否必填',
                    effect: "dark",
                    placement: "top-start",
                  },
                },
                [_c("i", { staticClass: "el-icon-question" })]
              ),
            ],
            1
          ),
          _c("el-switch", {
            model: {
              value: _vm.activeData.config.otherRequired,
              callback: function ($$v) {
                _vm.$set(_vm.activeData.config, "otherRequired", $$v)
              },
              expression: "activeData.config.otherRequired",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "至少应选" } },
        [
          _c(
            "span",
            { attrs: { slot: "label" }, slot: "label" },
            [
              _vm._v(" 至少应选 "),
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    content:
                      "至少应选需要和最多可选一起使用，并且小于最多可选，否则将导致多选无法选中",
                    effect: "dark",
                    placement: "top-start",
                  },
                },
                [_c("i", { staticClass: "el-icon-question" })]
              ),
            ],
            1
          ),
          _c("el-input-number", {
            attrs: {
              min: 0,
              value: _vm.activeData.min,
              placeholder: "至少应选",
            },
            on: {
              input: function ($event) {
                return _vm.$set(
                  _vm.activeData,
                  "min",
                  $event ? $event : undefined
                )
              },
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "最多可选" } },
        [
          _c("el-input-number", {
            attrs: {
              min: 0,
              value: _vm.activeData.max,
              placeholder: "最多可选",
            },
            on: {
              input: function ($event) {
                return _vm.$set(
                  _vm.activeData,
                  "max",
                  $event ? $event : undefined
                )
              },
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "排列方式" } },
        [
          _c(
            "el-radio-group",
            {
              directives: [
                { name: "removeAriaHidden", rawName: "v-removeAriaHidden" },
              ],
              model: {
                value: _vm.activeData.config.inline,
                callback: function ($$v) {
                  _vm.$set(_vm.activeData.config, "inline", $$v)
                },
                expression: "activeData.config.inline",
              },
            },
            [
              _c("el-radio-button", { attrs: { label: true } }, [
                _vm._v(" 横向 "),
              ]),
              _c("el-radio-button", { attrs: { label: false } }, [
                _vm._v(" 纵向 "),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        [
          _c(
            "span",
            { attrs: { slot: "label" }, slot: "label" },
            [
              _vm._v(" 多选互斥 "),
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    content:
                      "设置多选互斥后，将不可以选择其他选项。例如选择「以上都不是」。",
                    effect: "dark",
                    placement: "top-start",
                  },
                },
                [_c("i", { staticClass: "el-icon-question" })]
              ),
            ],
            1
          ),
          _c("el-switch", {
            model: {
              value: _vm.activeData.config.withExclusiveChoice,
              callback: function ($$v) {
                _vm.$set(_vm.activeData.config, "withExclusiveChoice", $$v)
              },
              expression: "activeData.config.withExclusiveChoice",
            },
          }),
        ],
        1
      ),
      _vm.activeData.config.withExclusiveChoice
        ? _c(
            "el-form-item",
            { staticClass: "exclusive-choice-api-codes" },
            [
              _c(
                "el-select",
                {
                  attrs: { multiple: "", placeholder: "请选择" },
                  model: {
                    value: _vm.activeData.config.exclusiveChoiceApiCodes,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.activeData.config,
                        "exclusiveChoiceApiCodes",
                        $$v
                      )
                    },
                    expression: "activeData.config.exclusiveChoiceApiCodes",
                  },
                },
                _vm._l(_vm.activeData.config.options, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("config-item-option", { attrs: { "active-data": _vm.activeData } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }